import './index.css'
import { Tabs, Tab } from 'react-bootstrap';
import React from 'react';



const Safety = () => {
    // const [key, setKey] = useState('overview');

    return(
        
        <div id = "testimonialPage">
       
            <div id = "SafetyHeader">Trust and Safety</div>

            <div id = "Body">


                <div id = "subHeader">Your Trust and Safety are our Priority</div>


                <div className="profile-tabs">
                    <Tabs defaultActiveKey={"overview"}>

                        <Tab eventKey="overview" title="Overview" tabClassName="profile-tabitem">

                            <div id = "centerBlockSafety">  
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
                                 erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanc
                                 tus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidu
                                 nt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clit
                                 a kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr
                                 , sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et ju
                                 sto duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est 
                                <br/>
                                <br/>
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquy
                                am erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata s
                                anctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor inv
                                idunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet c
                                lita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing eli
                                tr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et j
                                usto duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est 
                            </div>

                            <br/>

                        </Tab>

                        <Tab eventKey="clients" title="Clients" tabClassName="profile-tabitem">

                            <div id = "centerBlockSafety">  
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam 
                                erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctu
                                s est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt u
                                t labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd
                                 gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed di
                                 am nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo do
                                 lores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est 
                            </div>

                        </Tab>

                        <Tab eventKey="coaches" title="Coaches" tabClassName="profile-tabitem">

                            <div id = "centerBlockSafety">  
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam 
                                erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctu
                                s est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt u
                                t labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd
                                 gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed di
                                 am nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo d
                                 olores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est 
                            </div>

                        </Tab>
                        
                        <Tab eventKey="community" title="Community" tabClassName="profile-tabitem">

                            <div id = "centerBlockSafety">  
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore 
                                et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita 
                                kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing 
                                elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et 
                                accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. 
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna 
                                aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea 
                                takimata sanctus est 
                            </div>

                            <br/>

                        </Tab>

                        <Tab eventKey="students" title="Students" tabClassName="profile-tabitem">

                            <div id = "centerBlockSafety">  
                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam 
                                erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata 
                                sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor 
                                invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet 
                                clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing e
                                litr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et 
                                justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est 
                            </div>             

                        </Tab>

                    </Tabs>
                </div>

                <div id = "subHeader2">Safety by Design: Safety in Mind</div>

                <div id = "safetyRow" className = "row d-flex justify-content-center">

                    <div id = "safetyCol" className = "col-sm-4 mx-auto">
                            <div id= "imagePlaceHolder">Image</div>
                            <div id = "imageHeader">Background Checks</div>
                            <div id = "imageText">
                                Save time by effortlessly searching for certified Health and Wellness near you. All of our coaches go through extensive background checks.
                            </div>
                    </div>
                    
                    <div id = "safetyCol" className = "col-sm-4 mx-auto">
                    
                            <div id= "imagePlaceHolder">Image</div>
                            <div id = "imageHeader">Secure Payments</div>
                            <div id = "imageText">
                            Quickly review the coaches profile and book on the spot! Every session through EvolvU can be booked online within minutes and all financial transactions are securely processed.
                            </div>
                    </div>
                    
                    <div id = "safetyCol" className = "col-sm-4 mx-auto">
                            <div id= "imagePlaceHolder">Image</div>
                            <div id = "imageHeader">Account Protection</div>
                            <div id = "imageText">
                            Get started on your journey with coaches you can trust. EvolvU takes the stress out of finding a health and wellness coach so that you can spend more time focusing in sessions!
                            </div>
                    </div>

                </div>

                <div id = "safetyRow" className = "row d-flex justify-content-center" style = {{marginTop: "50px", marginBottom: "50px"}}>

                    <div id = "safetyCol" className = "col-sm-4 mx-auto">
                            <div id= "imagePlaceHolder">Image</div>
                            <div id = "imageHeader">Scan Protection</div>
                            <div id = "imageText">
                                Save time by effortlessly searching for certified Health and Wellness near you. All of our coaches go through extensive background checks.
                            </div>
                    </div>

                    <div id = "safetyCol" className = "col-sm-4 mx-auto">
                            <div id= "imagePlaceHolder">Image</div>
                            <div id = "imageHeader">Secure</div>
                            <div id = "imageText">
                                Get started on your journey with coaches you can trust. EvolvU takes the stress out of finding a health and wellness coach so that you can spend more time focusing in sessions!
                            </div>
                    </div>

                </div>

                <div id = "subHeader">We are Here if You Need Us</div>

                <div style = {{marginTop: "2rem", marginBottom: "4rem"}}> 
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam 
                    erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata 
                    sanctus est Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam 
                    erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata 
                    sanctus est.

                </div>

            </div>

        </div>
    )

}

export default Safety;